import { axisLeft } from 'd3-axis';
import { select } from 'd3-selection';
import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';

import { formatDescriptorValue } from '@/features/statisticsPage/utils';

class LeftYAxis extends Component {
  static propTypes = {
    descriptor: PropTypes.object.isRequired,
    minX: PropTypes.number.isRequired,
    maxX: PropTypes.number.isRequired,
    scale: PropTypes.func.isRequired,
  };

  gElement = createRef();

  getAxis = () => {
    const { scale, maxX, minX } = this.props;

    return axisLeft(scale)
      .tickFormat(this.formatValue)
      .ticks(6)
      .tickSize(-(maxX - minX));
  };

  componentDidMount() {
    this.renderD3();
  }

  componentDidUpdate() {
    this.renderD3();
  }

  formatValue = datum => {
    const { descriptor } = this.props;

    return formatDescriptorValue(descriptor, datum);
  };

  render() {
    return <g ref={this.gElement} />;
  }

  renderD3() {
    const element = select(this.gElement.current);
    const { classes, minX } = this.props;
    const leftYAxis = this.getAxis();

    element
      .attr('class', classes.leftYAxis)
      .attr('transform', `translate(${minX},0)`)
      .call(leftYAxis);
  }
}

export default LeftYAxis;
